<template>
    <div>
      <MdTitle v-bind:Text="$t('Shared.PatientAdmissions')" />

      <div class="flex-container">
        <div class="row">
          <div class="col-sm-12 col-md-12 mb-4">
            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                <div class="input-group" dir="ltr">
                      <input 
                        type="text" 
                        class="form-control"
                        :dir="dirInput"
                        v-model="parameter.SearchCriteria"   
                          @keyup.enter="LoadAdmission"                            
                      >
                      <div class="input-group-append">
                          <div class="input-group-append">
                          <MdButton 
                            v-bind:Name="'btnsearchinput'"
                            v-bind:VariantProp="'btn btn-sm search-attached'"
                            v-bind:IconClass="'mdi mdi-magnify'"
                            v-on:click="LoadAdmission">
                          </MdButton>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <b-row>
          <b-col lg="3" md="3" sm="12">
             <MdDateTime 
              :Label="$t('Shared.AdmissionDateFrom')" 
              :Model="dateFrom"                           
              @input="dateFrom = $event"                            
              :Id="'AdmissionsViewRepDateFrom'"
              :Type="'date'" 
              :OnPressEnter="LoadAdmission"                         
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isAdmDateFromValid">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdDateTime 
              :Label="$t('Shared.AdmissionDateTo')" 
              :Model="dateTo"                           
              @input="dateTo = $event"                            
              :Id="'AdmissionsViewRepDateTo'"
              :Type="'date'" 
              :OnPressEnter="LoadAdmission"                         
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isAdmDateToValid">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdDateTime 
              :Label="$t('Shared.DischargeDateFrom')" 
              :Model="dischargeDateFrom"                           
              @input="dischargeDateFrom = $event"                            
              :Id="'AdmissionsViewRepdischargeDateFrom'"
              :Type="'date'" 
              :OnPressEnter="LoadAdmission"                         
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDisDateFromValid">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdDateTime 
              :Label="$t('Shared.DischargeDateTo')" 
              :Model="dischargeDateTo"                           
              @input="dischargeDateTo = $event"                            
              :Id="'AdmissionsViewRepDischargeDateTo'"
              :Type="'date'" 
              :OnPressEnter="LoadAdmission"                         
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDisDateToValid">
          </MdDateTime>
          </b-col>
        </b-row>
        <b-row>
        <b-col lg="3" md="3" sm="12">
            <MdDateTime 
              :Label="$t('Shared.ActiveAdmissionDateFrom')" 
              :Model="activeAdmissionDateFrom"                           
              @input="activeAdmissionDateFrom = $event"                            
              :Id="'AdmissionsViewRepActiveAdmissionDateFrom'"
              :Type="'date'" 
              :OnPressEnter="LoadAdmission"                         
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isActDateFromValid">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">
             <MdDateTime 
              :Label="$t('Shared.ActiveAdmissionDateTo')" 
              :Model="activeAdmissionDateTo"                           
              @input="activeAdmissionDateTo = $event"                            
              :Id="'AdmissionsViewRepActiveAdmissionDateTo'"
              :Type="'date'" 
              :OnPressEnter="LoadAdmission"                         
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isActDateToValid">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.Patient',2)"
              v-bind:Options="PatientsOptions"
              v-bind:Model="PatientModel"
              v-bind:FieldDescription="'patientname'"
              v-bind:FieldCode="'patientcode'"
              v-bind:Multiple="false"
              v-bind:AllowEmpty="true"
              :Input="ChangePatients"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Shared.Status')"
              v-bind:Options="StatusOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'value'"
              v-bind:AllowEmpty="false"
              v-bind:Multiple="false"
              v-bind:ModelArray="StatusModel"  
              :Input="ChangeStatus"/>
          </b-col>                    
        </b-row>
        <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.Program')"
              v-bind:Options="ProgramOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:AllowEmpty="true"
              v-bind:Multiple="true"
              v-bind:Model="ProgramModel"  
              :Input="ChangeProgram"/>
          </b-col>
          <b-col md="3" lg="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Shared.Building')"
              v-bind:Options="BuildingOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:Model="BuildingModel"                       
              v-bind:Multiple="false"
              :Input="ChangeBuilding"
            />
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.Grouping')"
              v-bind:Options="GroupingOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:AllowEmpty="true"
              v-bind:Multiple="false"
              v-bind:Model="GroupingModel"  
              :Input="ChangeGrouping"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="LoadAdmission"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col>
        </b-row>
        </div>
        <div class="row">
          <div class="col-md-12">
              <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                        v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
              <div class="row">
                <div class="col-md-12">
                  <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    v-bind:IsViewListAdmission="true"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    v-bind:FieldsDate="FieldsDateArr">
                  </MdTable>
                </div>
            </div>
          </div>
        </div>
        
        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>
            
          <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>
        </div>
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="reportTitle"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="Admissions"
          :ReportName="'AdmissionsView'"
          :ReportTitle="reportTitle"
          :IsAnAPIReport="true"
        />
    </DxPopup>
      <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="$t('Admission.Admission')"
        v-bind:sendEmailAPI="'/Utils/sendEmail'"
        v-bind:exportCsvAPI="'/PatientRegistrations/exportCSV'"
    >    
    </CSVExportHelper>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import EnumService from "@/services/enum.service";
    import PatientService from '@/services/patient.service'
    import ProgramService from '@/services/programs.services'
    import Utils from '../../../common/utils'
    import DBFunctions from '@/common/DBFunctions.js'
    import AdmissionService from '@/services/admission.service'
    import ClinicalService from '@/services/clinical.service'
    import { EventBus } from '@/event-bus.js';

    export default Vue.extend({
        name: "AdmissionsViewRep",
        mixins: [ ShowMessage, Utils, DBFunctions ],
        components: { DxPopup },
        data() {
            return {
                isReportVisible: false,
                reportParams: [],
                showFilters: true,
                PatientsOptions: [],
                ProgramOptions: [],
                BuildingOptions: [],
                StatusOptions: EnumService.AdmissionsStatusOptions,
                StatusModel: {},
                PatientModel: '',
                ProgramModel: '',
                BuildingModel: '',
                GroupingModel: '',
                parameter:{
                  SearchCriteria:'',
                  PageNumber : null,
                  PageSize:null,
                  Status: true,
                  IsInpatient: null,
                },
                paramStatus: '',
                reportTitle: this.$t('Admission.Admission'),
                paramPatient: '',
                paramProgram: '',
                paramBuilding: '',
                fullParam: {
                  PageSize:0,
                  PageNumber:0
                },
                GroupingOptions: [{"value":"programCode","name":this.$tc('Shared.Program')}],
                dateFrom: null,
                dateTo: null,
                dischargeDateFrom: null,
                dischargeDateTo: null,
                activeAdmissionDateFrom: null,
                activeAdmissionDateTo: null,
               items: [],         
                fields: [
                  { key: 'patientName', sortable: true, label: this.$tc('Shared.PatientName'), class: 'text-rigth' },
                  { key: 'nickname', sortable: true, label: this.$tc('Shared.NickName'), class: 'text-rigth' },
                  { key: 'patientCode', sortable: true, label: this.$t('Shared.PatientCode'), class: 'text-rigth' } ,
                  { key: 'dob', sortable: true, label: this.$tc('Shared.Dob'), class: 'text-rigth' },
                  { key: 'programName', sortable: true, label: this.$tc('Shared.Program'), class: 'text-rigth' },
                  { key: 'dateFrom', sortable: true, label: this.$t('Shared.datefrom'), class: 'text-rigth' },
                  { key: 'dateTo', sortable: true, label: this.$t('Shared.dateTo'), class: 'text-rigth' },   
                  { key: 'transactionType', sortable: true, label: this.$t('Shared.TransactionType'), class: 'text-rigth' },       
                  { key: 'status', sortable: true, label: this.$t('Shared.Status'), class: 'text-rigth' },
                  { key: 'chartNo', sortable: true, label: this.$t('Shared.ChartNumber'), class: 'text-center' },       
                  { key: 'isInpatientTranslated', sortable: true, label: this.$t('Shared.Inpatient') },
                  { key: 'buildingName', sortable: true, label: this.$t('Shared.Building'), class: 'text-center' },
                  { key: 'roomName', sortable: true, label: this.$tc('Shared.Room'), class: 'text-center' },              
                ],
                pageOptions: [5, 10, 15 ],
                totalRows: 0,
                currentPage: 1,
                perPage: 10,
                selected: [],
                Header:{},
                refTable: 'selectableTable', 
                ShowMessageIsEmpty:true,
                FieldsDateArr:['dateFrom','dateTo'],
                dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
                isAdmDateFromValid: true,
                isAdmDateToValid: true,
                isActDateFromValid: true,
                isActDateToValid: true,
                isDisDateFromValid: true,
                isDisDateToValid: true,     
            }
        },
        methods: {

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.isReportVisible = false
            },

            reportList() {
              this.checkExistFavorite('/app/reports/patients');
              this.$router.push({ name: "reportListPatient" }).catch(()=>{});
            },

            initializeParameters() {
              this.parameter.paramProgram = this.paramProgram && this.paramProgram !== ''
                ? this.paramProgram
                : null;
              this.parameter.Status = (this.StatusModel.value === 'all') ? null : this.StatusModel.value;
              this.parameter.paramBuilding = (this.paramBuilding === '') ? null : this.paramBuilding;
              this.parameter.DateFrom = this.dateFrom;
              this.parameter.DateTo = this.dateTo;
              this.parameter.DischargeDateFrom = this.dischargeDateFrom;
              this.parameter.DischargeDateTo = this.dischargeDateTo;
              this.parameter.ActiveAdmissionDateFrom = this.activeAdmissionDateFrom;
              this.parameter.ActiveAdmissionDateTo = this.activeAdmissionDateTo;
              this.parameter.PatientCode = this.paramPatient;
            },

            initializePdfParameters() {
              this.reportParams = []
              this.reportParams.push({ paramName: 'dateFrom', paramValue: this.dateFrom})
              this.reportParams.push({ paramName: 'dateTo', paramValue: this.dateTo})
              this.reportParams.push({ paramName: 'dischargeDateFrom', paramValue: this.dischargeDateFrom})
              this.reportParams.push({ paramName: 'dischargeDateTo', paramValue: this.dischargeDateTo})
              this.reportParams.push({ paramName: 'activeAdmissionDateFrom', paramValue: this.activeAdmissionDateFrom})
              this.reportParams.push({ paramName: 'activeAdmissionDateTo', paramValue: this.activeAdmissionDateTo})
              this.reportParams.push({ paramName: 'building', paramValue: this.paramBuilding})
              this.reportParams.push({ paramName: 'program', paramValue: this.paramProgram})
              this.reportParams.push({ paramName: 'status', paramValue: this.StatusModel.value})
              this.reportParams.push({ paramName: 'patientCode', paramValue: this.paramPatient})
              this.reportParams.push({ paramName: 'grouping', paramValue: this.GroupingModel ? this.GroupingModel.value : null})
              this.reportParams.push({ paramName: 'rSearchCriteria', paramValue: this.parameter.SearchCriteria})
            },
            
            onClickShowReport() {
              if (!this.validateForm()) return;

              this.initializePdfParameters();
              this.isReportVisible = true
              this.$refs.Admissions.buildDocument(this.reportParams)
            },

            getPatients(){   
              PatientService.getAll(this.fullParam)
              .then((response) => {
              if(response.status == '200' && response.data && response.data.length > 0) {
                this.PatientsOptions = response.data;                 
                this.PatientsOptions.forEach(function(element) {	
                    element.patientname = element.firstname + " " + element.lastname + " - "+element.patientcode;   
                });       
              }       
              })
              .catch(error => {      
                if (!error.response) {
                    // network error
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                } else {
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
              });    
            },

            getPrograms(){   
              ProgramService.getAll(this.fullParam)
              .then((response) => {
              if(response.status == '200' && response.data && response.data.length > 0) {
                this.ProgramOptions = response.data;                  
              }       
              })
              .catch(error => {      
                if (!error.response) {
                    // network error
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                } else {
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
              });    
            },

            getBuildings(){
              AdmissionService.getBuildings()
                .then((response) => {
                    if(response.status == '200'){
                        this.BuildingOptions = response.data; 
                    }                             
                })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
            },


            ChangeStatus(item) {
              if(item != null){
                this.StatusModel = item;
                this.paramStatus = item.code
              }else{
                this.StatusModel = null;
              }
            },

            ChangePatients(item) {
              if(item != null){
                this.PatientModel = item;
                this.paramPatient = item.patientcode
              }else{
                this.PatientModel = null;
                this.paramPatient = ''
              }
            },

            ChangeGrouping(item) {
              if(item != null){
                this.GroupingModel = item;
              }else{
                this.GroupingModel = null;
              }
            },

            ChangeProgram(item) {
              if(item != null){
                this.ProgramModel = item;

                this.paramProgram = [];
                let selectedProgram = [];
                item.forEach(function(item) {   
                  selectedProgram.push(item.code);               
                });
                this.paramProgram = selectedProgram;
              }else{
                this.ProgramModel = null;
              }
            },

            ChangeBuilding(item) {
              if(item != null){
                this.BuildingModel = item;
                this.paramBuilding = item.code
              }else{
                this.BuildingModel = null;
                this.paramBuilding = ''
              }
            },

            LoadAdmission(){
              if (!this.validateForm()) return;
              this.items = [];
              this.currentPage = 1;
              this.parameter.PageNumber = 1;
              this.totalRows = this.items.length;
              this.SearchAdmission();
            },

            pageChanged (page) {            
              this.currentPage = page;   
              this.SearchAdmission(); 
            },

            PerPageFunction(perpage){
              this.perPage = perpage;  
              this.currentPage = 1;
              this.SearchAdmission();
            },

            onRowSelected(items) {    
              this.selected = items;
            },

            onFiltered(filteredItems) {
              this.totalRows = filteredItems.length
              this.currentPage = 1
            },

            SearchAdmission(){
              this.parameter.PageNumber = this.currentPage;
              this.parameter.PageSize = this.perPage;
              this.initializeParameters();              

              ClinicalService.getAllByPatientCode(this.parameter, true)
                .then((response) => {
                  if(response.status == '200' && response.data){
                    this.items = response.data;
                    if(response.data.length > 0){                        
                    this.items.forEach(function(element) {
                        let { dob, dateFrom, dateTo } = element
                        if (dob) element.dob = Utils.formatterDateToString(dob);  
                        if (dateFrom) element.dateFrom = Utils.formatterDateToString(dateFrom);        
                        if (dateTo) element.dateTo =  Utils.formatterDateToString(dateTo);           
                    });
                    let headerString = response.headers["x-pagination"];
                    this.Header = JSON.parse(headerString);
                    this.totalRows = this.Header.TotalCount;
                    }
                  }  
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                }); 
            },

            handleCSV(action) {
              if (!this.validateForm()) return;

              this.initializeParameters();
              switch(action) {
                case 'export':
                  this.$refs.csvExportHelper.exportCSV(this.parameter);
                break;
                case 'email':
                  this.$refs.csvExportHelper.emailCSV(this.parameter);
                break;
                default:
                  console.warn('unknow action:', action);
                break;
              }
            },
          
            handlePdf(action) {
              if (!this.validateForm()) return;

              this.initializePdfParameters();
              switch(action) {
                case 'export':
                  this.$refs.csvExportHelper.exportToPdf('AdmissionsView', true, false, this.reportParams);
                break;
                case 'email':
                  this.$refs.csvExportHelper.emailPdf('AdmissionsView', true, false, this.reportParams);
                break;
                default:
                  console.warn('unknow action:', action);
                break;
              }
            },

            // Método de validación reutilizable
            validateForm() {
              const isValid = this.validateAllRanges();

              // Forzar actualización del componente
              this.$forceUpdate();

              if (!isValid) {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), "error");
                return false;
              }
              return true;
            },

            validateAllRanges() {
              const ranges = [
                  { from: this.dateFrom, to: this.dateTo, index: 1 },
                  { from: this.dischargeDateFrom, to: this.dischargeDateTo, index: 2 },
                  { from: this.activeAdmissionDateFrom, to: this.activeAdmissionDateTo, index: 3 }
              ];
              
              for (const range of ranges) {
                  const isValid = Utils.isDateFromAndDateTo(range.from, range.to)
                  let index = range.index
                  if (!isValid) {
                      switch (index) {
                        case 1: this.isAdmDateFromValid = this.isAdmDateToValid =  isValid;
                          break;
                        case 2: this.isDisDateFromValid = this.isDisDateToValid = isValid;
                          break;
                        default: this.isActDateFromValid = this.isActDateToValid = isValid;
                          break;
                      }
                      return false; // early exit
                  } else {
                     // reset state when validation is ok
                    this.isAdmDateFromValid = this.isAdmDateToValid = isValid;
                    this.isDisDateFromValid = this.isDisDateToValid = isValid;
                    this.isActDateFromValid = this.isActDateToValid = isValid;
                  }
              }
              return true;
            }
        },

        async created(){
        },
        
        mounted () {
          this.getPatients()
          this.getPrograms()
          this.getBuildings()
          this.StatusModel = {"value":"all","name": this.$t('Shared.All')};
          EventBus.$on("ShowWeel", function (isShow) { 
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
